import { useSelector } from "react-redux";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { warehouses } from "../../../../../../redux/ware-houses/action";
import { selectWarehousesListItems } from "../../../../../../redux/ware-houses/selector";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";

const ManagementWarehouses = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
  const [pageData, setPageData] = useState(1)
    const warehouseItems = useSelector(selectWarehousesListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'WarehouseInfo.WarehouseName', headerName: 'Warehouse Name' },
      { field: 'WarehouseInfo.OrganizationUnitName', headerName: 'OrganizationUnit Name' },
      { field: 'WarehouseInfo.StoreName', headerName: 'Store Name' },
      { field: 'WarehouseInfo.WarehouseEmail', headerName: 'WarehouseEmail' },
      { field: 'WarehouseInfo.WarehousePhoneNumber', headerName: 'Warehouse PhoneNumber' },
      { field: 'WarehouseInfo.IsPrimaryWarehouse', headerName: 'PrimaryWarehouse', cellRenderer: 'yesNoRenderer' }
      
        ]);
      }
    
      const fetchWarehouse=()=>{

        dispatch(warehouses.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/ware-houses/list`,entity:'warehouses',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
       
      }
	useEffect(() => {
        createColumnDefs()
        fetchWarehouse()
	}, [pageData])
  const additionButtons: any = [
    {
      name: 'Add Warehouse',
      callback: () => handleAdd(),
    },
    {
      name:'Go to Collection Points',
      callback: ()=> handleCollectionPointClick()
    },
  ];
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const handleCollectionPointClick=()=>{
    navigate('/management/organization/organization-management/collection-points')
  }
  const handleEdit=(data: any)=>{
    navigate(`${data?.WarehouseInfo?.Id}`)
  }
  const handleDelete=(data: any)=>{
    dispatch(warehouses.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/ware-houses/delete`,
      entity: 'warehouses',
      jsonData: {
          Records: [
              {
                  Id: data?.Id
              }
          ]
      }
  })).then(() => {
    dispatch(warehouses.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/ware-houses/list`,entity:'warehouses',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
  });
  } 
	return (
    <>
    {warehouseItems?.isLoading ? 
    <PageLoader />
:   
		<Table columnData={columnDefs} rowData={warehouseItems?.result?.items} setPageData={setPageData} 
    paginationData={warehouseItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Warehouses" />
     
  }
  </> 
	);
};

export default ManagementWarehouses;


